module.exports = __webpack_public_path__ + "img/favatar.152c3dcd.png";